/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import { addResponseRequest } from "../../../../actions/admin/cancelreschedulerequest";
import ApproveConfirmationModal from "./ApproveConfirmationModal";
import RejectConfirmationModal from "./RejectConfirmationModal";
import SuccessNotification from "./SuccessNotification";
import moment from "moment-timezone";

const PaymentDetails = ({
    data,
    isDeferredPayment
}) => {
    const [note, setNote] = useState("");
    const [processingAction, setProcessingAction] = useState(null); // 'approved' | 'rejected' | null
    const [showApproveModal, setShowApproveModal] = useState(false);
    const [showRejectModal, setShowRejectModal] = useState(false);
    const [successMessage, setSuccessMessage] = useState(null);

    const adminResponseHandler = async (id, response) => {
        if (processingAction) return;
        setProcessingAction(response);
        try {
            const submitResponse = await addResponseRequest({ requestId: id, status: response, notes: note });
            if (submitResponse.desc === "SUCCESS") {
                setShowApproveModal(false);
                setShowRejectModal(false);
                setSuccessMessage(response === "approved" ? "Booking Modification Approved" : "Booking Modification Rejected");
                setTimeout(() => window.location.reload(), 10000);
            } else {
                console.error("Response failed:", JSON.stringify(submitResponse));
                setProcessingAction(null);
            }
        } catch (err) {
            console.error(err);
            setProcessingAction(null);
        }
    }

    const getApproveButtonText = () => {
        if (processingAction === "approved") return "Processing...";
        if (data?.chargeAmount > 0) {
            if (isDeferredPayment) {
                return `Approve & Update Price`;
            } else {
                return `¥ Charge ${data.chargeAmount.toLocaleString()} JPY`;
            }
        }
        return "Approve";
    }

    const getPaymentReceivedText = () => {
        if (data?.status === "APPROVED") {
            if (data?.paymentStatus === "CHARGED") {
                if (data?.previousBooking?.paymentStatus === "CHARGED" || data?.previousBooking?.paymentStatus === "ADDED_TO_MONTHLY_TOTAL") {
                    return (data?.previousBooking?.totalPrice + data?.chargeAmount).toLocaleString() + " JPY";
                } else {
                    return data?.chargeAmount?.toLocaleString() + " JPY";
                }
            } else {
                if (data?.previousBooking?.paymentStatus === "CHARGED" || data?.previousBooking?.paymentStatus === "ADDED_TO_MONTHLY_TOTAL") {
                    return data?.previousBooking?.totalPrice?.toLocaleString() + " JPY";
                } else {
                    return "-";
                }
            }
        }

        if (data?.bookingId?.paymentStatus === "CHARGED" || data?.bookingId?.paymentStatus === "ADDED_TO_MONTHLY_TOTAL") {
            return data?.bookingId?.totalPrice?.toLocaleString() + " JPY";
        }

        return "-";
    }

    const getFlywireDataDetails = (data) => {
        const flywireResponse = data?.flywireChargeResponse;

        return {
            chargeAccount: flywireResponse?.reference?.startsWith("XWE") ? "TLF" : "JPT",
            status: {
                text: flywireResponse?.status === "success" ? "guaranteed" : "pending",
                style: flywireResponse?.status === "success" ? "#3CAEA3" : "#F9A825"
            },
            chargedOn: data?.chargedAt,
            token: data?.flywireToken
        }
    }

    const getApprovedButtonText = (data) => {
        if (data?.requestType === "cancel") {
            return "Booking Cancelled";
        } else {
            if (data?.paymentStatus === "CHARGED") {
                return `Charged ${data?.chargeAmount?.toLocaleString()} JPY`;
            } else {
                return "Approved";
            }
        }
    }

    return (
        <>
            <h5 className={`tw:!font-hanken-grotesk tw:!mb-4 tw:!text-[15px] tw:!font-[600] tw:!text-[#282828]`}>
                <span className="tw:relative tw:inline-block">
                    <span className="tw:absolute tw:bottom-0 tw:left-0 tw:right-0 tw:h-[40%] tw:rounded-full tw:bg-[#F9EDD3]" />
                    <span className="tw:relative">Payment Details</span>
                </span>
            </h5>
            {
                data?.status === "PENDING_APPROVAL" ? (
                    <>
                        <div className="border rounded mb-1">
                            <div className="d-flex align-items-center gap-5 p-3">
                                <div className="flex-shrink-0" style={{ width: '120px' }}>
                                    <b className="tw:!font-hanken-grotesk tw:!text-[15px] tw:!font-[700] tw:!text-[#4E4E4E]">
                                        {`Payment Details`}
                                    </b>
                                </div>
                                <div className="d-flex flex-wrap" style={{ flex: 1, columnGap: '3rem', rowGap: '0.75rem' }}>
                                    {
                                        !isDeferredPayment && (
                                            <div>
                                                <p className="tw:!font-hanken-grotesk tw:!m-0 tw:!text-[13px] tw:!font-[400] tw:!text-[#8D8D8D]">{"Payment Received"}</p>
                                                <b className="tw:!font-hanken-grotesk tw:!text-[15px] tw:!font-[400] tw:!text-[#282828]">{getPaymentReceivedText()}</b>
                                            </div>
                                        )
                                    }
                                    {
                                        data?.requestType === "reschedule" && (
                                            <div>
                                                <p className="tw:!font-hanken-grotesk tw:!m-0 tw:!text-[13px] tw:!font-[400] tw:!text-[#8D8D8D]">{data?.totalCancellationFee > 0 ? "Updated Booking Fee (New Price + Cancellation Fee)" : "Updated Booking Fee"}</p>
                                                <b className="tw:!font-hanken-grotesk tw:!text-[15px] tw:!font-[400] tw:!text-[#282828]">
                                                    {(data?.editBooking?.totalPrice + data?.totalCancellationFee).toLocaleString() + " JPY"}
                                                </b>
                                            </div>
                                        )
                                    }
                                    {
                                        (data?.refundAmount > 0 && !isDeferredPayment) && (
                                            <div>
                                                <p className="tw:!font-hanken-grotesk tw:!m-0 tw:!text-[13px] tw:!font-[400] tw:!text-[#8D8D8D]">Refund Amount</p>
                                                <b className="tw:!font-hanken-grotesk tw:!text-[15px] tw:!font-[400] tw:!text-[#282828]">
                                                    {data?.refundAmount?.toLocaleString() + " JPY"}
                                                </b>
                                            </div>
                                        )
                                    }
                                    {
                                        data?.chargeAmount > 0 && (
                                            <div>
                                                <p className="tw:!font-hanken-grotesk tw:!m-0 tw:!text-[13px] tw:!font-[400] tw:!text-[#8D8D8D]">{data?.totalCancellationFee > 0 ? "Additional Fee (Price Difference + Cancellation Fee)" : "Additional Fee"}</p>
                                                <b className="tw:!font-hanken-grotesk tw:!text-[15px] tw:!font-[400] tw:!text-[#282828]">
                                                    {data?.chargeAmount?.toLocaleString() + " JPY"}
                                                </b>
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="border rounded mb-5">
                            <div className="d-flex align-items-start gap-5 p-3">
                                <div className="flex-shrink-0" style={{ width: '120px' }}>
                                    <b className="tw:!font-hanken-grotesk tw:!text-[15px] tw:!font-[700] tw:!text-[#4E4E4E]">
                                        {`Approve`}
                                    </b>
                                </div>
                                <div className="d-flex flex-wrap" style={{ flex: 1, columnGap: '3rem', rowGap: '0.75rem' }}>
                                    <button
                                        type="button"
                                        disabled={!!processingAction || data?.status === "APPROVED" || data?.status === "REJECTED"}
                                        style={{ opacity: (!!processingAction || data?.status === "APPROVED" || data?.status === "REJECTED") ? 0.5 : 1 }}
                                        className="tw:!px-6 tw:!py-2 tw:!rounded-[5px] tw:!bg-[#3CAEA3] tw:!text-white tw:!text-[14px] tw:!font-[600] tw:!font-hanken-grotesk tw:!border-none tw:!cursor-pointer hover:tw:!opacity-90"
                                        onClick={() => setShowApproveModal(true)}
                                    >
                                        {getApproveButtonText()}
                                    </button>
                                </div>
                            </div>
                            <hr className="hr-E8E8E8 m-0" />
                            <div className="d-flex align-items-start gap-5 p-3">
                                <div className="flex-shrink-0" style={{ width: '120px' }}>
                                    <b className="tw:!font-hanken-grotesk tw:!text-[15px] tw:!font-[700] tw:!text-[#4E4E4E]">
                                        {`Reject`}
                                    </b>
                                </div>
                                <div className="d-flex flex-wrap" style={{ flex: 1, columnGap: '3rem', rowGap: '0.75rem' }}>
                                    <div className="tw:w-full">
                                        <p className="tw:!font-hanken-grotesk tw:!m-0 tw:!mb-2 tw:!text-[13px] tw:!font-[400] tw:!text-[#8D8D8D]">Rejection Message</p>
                                        <textarea
                                            className="tw:w-full tw:rounded-[5px] tw:border tw:border-[#e8e8e8] tw:bg-white tw:px-3 tw:py-2 tw:text-[14px] tw:placeholder:text-[12px] tw:font-hanken-grotesk tw:text-[#282828] tw:outline-none focus:tw:border-[#D4B055] tw:resize-y tw:min-h-[80px]"
                                            placeholder="Kindly enter the reason for the modification request rejection"
                                            disabled={!!processingAction || data?.status === "APPROVED" || data?.status === "REJECTED"}
                                            onChange={(e) => setNote(e.target.value)}
                                        />
                                        <button
                                            type="button"
                                            disabled={!!processingAction || data?.status === "APPROVED" || data?.status === "REJECTED" || note.trim() === ""}
                                            style={{ opacity: (!!processingAction || data?.status === "APPROVED" || data?.status === "REJECTED" || note.trim() === "") ? 0.5 : 1 }}
                                            className="tw:mt-3 tw:!px-6 tw:!py-2 tw:!rounded-[5px] tw:!bg-[#EA4335] tw:!text-white tw:!text-[14px] tw:!font-[600] tw:!font-hanken-grotesk tw:!border-none tw:!cursor-pointer hover:tw:!opacity-90"
                                            onClick={() => setShowRejectModal(true)}
                                        >
                                            {processingAction === "rejected" ? "Processing..." : "Reject"}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                ) : (
                    <div className="border rounded mb-1">
                        <div className="d-flex align-items-center gap-5 p-3">
                            {
                                data?.requestType === "reschedule" && (
                                    <div className="flex-shrink-0" style={{ width: "auto" }}>
                                        {data?.status === "APPROVED" ? (
                                            <button
                                                type="button"
                                                disabled={true}
                                                style={{ opacity: 0.5 }}
                                                className="tw:!px-6 tw:!py-2 tw:!rounded-[5px] tw:!bg-[#3CAEA3] tw:!text-white tw:!text-[14px] tw:!font-[600] tw:!font-hanken-grotesk tw:!border-none tw:!cursor-pointer hover:tw:!opacity-90"
                                            >
                                                {getApprovedButtonText(data)}
                                            </button>
                                        ) : (
                                            <button
                                                type="button"
                                                disabled={true}
                                                style={{ opacity: 0.5 }}
                                                className="tw:mt-3 tw:!px-6 tw:!py-2 tw:!rounded-[5px] tw:!bg-[#EA4335] tw:!text-white tw:!text-[14px] tw:!font-[600] tw:!font-hanken-grotesk tw:!border-none tw:!cursor-pointer hover:tw:!opacity-90"
                                            >
                                                Rejected
                                            </button>
                                        )}
                                    </div>
                                )
                            }
                            <div className="d-flex flex-wrap" style={{ flex: 1, columnGap: '3rem', rowGap: '0.75rem' }}>
                                {data?.status === "APPROVED" ? (
                                    <>
                                        {
                                            data?.userId?.deferredPaymentEligible ? (
                                                <>
                                                    <div>
                                                        <p className="tw:!font-hanken-grotesk tw:!m-0 tw:!text-[13px] tw:!font-[400] tw:!text-[#8D8D8D]">Updated Booking Price</p>
                                                        <b className="tw:!font-hanken-grotesk tw:!text-[15px] tw:!font-[400] tw:!text-[#282828]">
                                                            {(data?.editBooking?.totalPrice + data?.totalCancellationFee)?.toLocaleString() + " JPY"}
                                                        </b>
                                                    </div>
                                                </>
                                            ) : (
                                                <>
                                                    {
                                                        data?.paymentStatus === "CHARGED" ? (
                                                            <>
                                                                <div>
                                                                    <p className="tw:!font-hanken-grotesk tw:!m-0 tw:!text-[13px] tw:!font-[400] tw:!text-[#8D8D8D]">Total Payment Received</p>
                                                                    <b className="tw:!font-hanken-grotesk tw:!text-[15px] tw:!font-[400] tw:!text-[#282828]">{getPaymentReceivedText()}</b>
                                                                </div>
                                                                <div>
                                                                    <p className="tw:!font-hanken-grotesk tw:!m-0 tw:!text-[13px] tw:!font-[400] tw:!text-[#8D8D8D]">Flywire Charge Account</p>
                                                                    <b className="tw:!font-hanken-grotesk tw:!text-[15px] tw:!font-[400] tw:!text-[#282828]">
                                                                        {getFlywireDataDetails(data).chargeAccount}
                                                                    </b>
                                                                </div>
                                                                <div>
                                                                    <p className="tw:!font-hanken-grotesk tw:!m-0 tw:!text-[13px] tw:!font-[400] tw:!text-[#8D8D8D]">Status</p>
                                                                    <b className={`tw:!font-hanken-grotesk tw:!text-[15px] tw:!font-[400] tw:!text-[${getFlywireDataDetails(data).status?.style}]`}>
                                                                        {getFlywireDataDetails(data).status?.text}
                                                                    </b>
                                                                </div>
                                                                <div>
                                                                    <p className="tw:!font-hanken-grotesk tw:!m-0 tw:!text-[13px] tw:!font-[400] tw:!text-[#8D8D8D]">Charged On</p>
                                                                    <b className="tw:!font-hanken-grotesk tw:!text-[15px] tw:!font-[400] tw:!text-[#282828]">
                                                                        {moment.tz(getFlywireDataDetails(data).chargedOn, "Asia/Tokyo").locale("en").format("MMM D, YYYY H:mm")}
                                                                    </b>
                                                                </div>
                                                                <div>
                                                                    <p className="tw:!font-hanken-grotesk tw:!m-0 tw:!text-[13px] tw:!font-[400] tw:!text-[#8D8D8D]">Flywire Token</p>
                                                                    <b className="tw:!font-hanken-grotesk tw:!text-[15px] tw:!font-[400] tw:!text-[#282828] tw:!block tw:!max-w-[200px] tw:!overflow-hidden tw:!text-ellipsis tw:!whitespace-nowrap">
                                                                        {getFlywireDataDetails(data).token}
                                                                    </b>
                                                                </div>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <div>
                                                                    <p className="tw:!font-hanken-grotesk tw:!m-0 tw:!text-[13px] tw:!font-[400] tw:!text-[#8D8D8D]">Payment Received</p>
                                                                    <b className="tw:!font-hanken-grotesk tw:!text-[15px] tw:!font-[400] tw:!text-[#282828]">{getPaymentReceivedText()}</b>
                                                                </div>
                                                                {
                                                                    data?.requestType === "reschedule" && (
                                                                        <div>
                                                                            <p className="tw:!font-hanken-grotesk tw:!m-0 tw:!text-[13px] tw:!font-[400] tw:!text-[#8D8D8D]">New Price</p>
                                                                            <b className="tw:!font-hanken-grotesk tw:!text-[15px] tw:!font-[400] tw:!text-[#282828]">
                                                                                {(data?.editBooking?.totalPrice + data?.totalCancellationFee).toLocaleString() + " JPY"}
                                                                            </b>
                                                                        </div>
                                                                    )
                                                                }
                                                                {
                                                                    data?.refundAmount > 0 && (
                                                                        <div>
                                                                            <p className="tw:!font-hanken-grotesk tw:!m-0 tw:!text-[13px] tw:!font-[400] tw:!text-[#8D8D8D]">Refund Amount</p>
                                                                            <b className="tw:!font-hanken-grotesk tw:!text-[15px] tw:!font-[400] tw:!text-[#282828]">
                                                                                {data?.refundAmount?.toLocaleString() + " JPY"}
                                                                            </b>
                                                                        </div>
                                                                    )
                                                                }
                                                            </>
                                                        )
                                                    }
                                                </>
                                            )
                                        }
                                    </>
                                ) : (
                                    <>
                                        <div>
                                            <p className="tw:!font-hanken-grotesk tw:!m-0 tw:!text-[13px] tw:!font-[400] tw:!text-[#8D8D8D]">Rejection Message</p>
                                            <b className="tw:!font-hanken-grotesk tw:!text-[15px] tw:!font-[400] tw:!text-[#282828]">{data?.notes ? data?.notes : "-"}</b>
                                        </div>
                                    </>
                                )}
                            </div >
                        </div >
                    </div >
                )
            }
            {/* Approve Confirmation Modal */}
            {
                showRejectModal && (
                    <RejectConfirmationModal
                        data={data}
                        note={note}
                        processingAction={processingAction}
                        onClose={() => setShowRejectModal(false)}
                        onConfirm={() => adminResponseHandler(data._id, 'rejected')}
                    />
                )
            }
            {
                showApproveModal && (
                    <ApproveConfirmationModal
                        data={data}
                        isDeferredPayment={isDeferredPayment}
                        processingAction={processingAction}
                        onClose={() => setShowApproveModal(false)}
                        onConfirm={() => adminResponseHandler(data._id, 'approved')}
                    />
                )
            }
            {
                successMessage && (
                    <SuccessNotification
                        message={successMessage}
                        onClose={() => setSuccessMessage(null)}
                    />
                )
            }
        </>
    )
};

export default PaymentDetails;
